import Controller from '@ember/controller';
import { inject as controller } from '@ember/controller';
import { service } from '@ember/service';

export default class ResourcesPeopleInactiveController extends Controller {
  @controller('resources/people') peopleController;
  @service store;

  get breakout() {
    return this.peopleController.breakout;
  }

  get people() {
    return this.store.peekAll('person').filter((person) => !person.active);
  }
}
